import { useToasts } from "@utils/hooks/useToasts";
import cn from "classnames";
import React from "react";
import styles from "./SmallLink.module.scss";
import { SmallLinkPropsI } from "./SmallLink.props";
import { makeNotifs } from "@utils/makeNotifs";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";

export default function SmallLink({
  className,
  children,
  link,
  copy,
  pulse,
  onClick,
}: SmallLinkPropsI) {
  const { ok } = makeNotifs();
  const { onSuccess } = useGlobalNotifs();
  if (link) {
    return (
      <a className={cn(styles.wrapper, className)} href={link}>
        {children}
      </a>
    );
  }

  const onClickHandler = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    onClick && onClick(e);
    copy &&
      navigator.clipboard
        .writeText(children?.toString() || "")
        .then(() => {
          onSuccess(ok.copied);
        })
        .catch((e) => console.error(e));
  };

  return (
    <span
      className={cn(
        styles.wrapper,
        {
          [styles.pulse]: pulse,
        },
        className
      )}
      onClick={onClickHandler}
      title={pulse}
    >
      {children}
    </span>
  );
}
